
export const normalizeUrl = (path: string | undefined | null): string => {
  if (!path || typeof path !== 'string') {
    return '';
  }
  const hasLeadingSlash = path.startsWith('/');
  const cleaned = path.replace(/^\/+/, "").replace(/\/+$/, "").replace(/\/+/g, "/");
  return hasLeadingSlash ? "/" + cleaned : cleaned;
};
